import React from "react";
import { Box, Typography } from "@mui/material";

const HoverOverlay = ({ children, message }) => {
    return (
        <Box position="relative" width="100%" height="100%">
            {/* The child component */}
            <Box
                sx={{
                    pointerEvents: "none", // Prevents interaction with the child
                    filter: "blur(3px)", // Adds a blur effect to the child content
                    opacity: 0.6, // Dims the child content
                }}
            >
                {children}
            </Box>

            {/* Overlay */}
            <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bgcolor="rgba(0, 0, 0, 0.7)" // Dark overlay
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                zIndex={10}
                sx={{
                    pointerEvents: "all", // Blocks interactions completely
                }}
            >
                {/* Animated Loader */}
                {/* <CircularProgress
          size={50}
          sx={{ color: "white", mb: 2 }} // White spinner with spacing below
        /> */}
                <svg fill="#FFFFFF" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                    width="80px" height="80px" viewBox="0 0 256 220" enable-background="new 0 0 256 220" >
                    <path d="M133.202,84.142c5.795,0,10.493,4.698,10.493,10.493s-4.698,10.493-10.493,10.493s-10.493-4.698-10.493-10.493
	S127.406,84.142,133.202,84.142z M94.71,147.731l-0.097-0.097l0,0c-0.435-0.29-0.822-0.532-1.161-0.919l1.161,13.298L80.01,180.71
	c-2.079,2.998-1.354,7.06,1.547,9.139c2.998,2.079,7.06,1.354,9.139-1.547l15.764-22.727c0.822-1.161,1.354-2.708,1.161-4.255
	l-0.532-6.431L94.71,147.731z M138.086,191.01h62.573l-11.702-36.509c0,0-6.625,1.644-19.729,15.571
	c-0.29,0.29-0.629,0.629-0.919,0.919l-31.625-18.279c0.532-1.015,0.629-2.176,0.435-3.433L125.9,107.692
	c-0.919-4.062-4.545-7.157-8.801-7.157H96.161c-1.547,0-3.095,0.822-3.965,2.176l-10.445,18.134
	c-1.354,2.176-0.532,4.981,1.644,6.238l11.702,6.722l-1.547,2.611c-1.886,3.095-0.822,7.06,2.369,8.801l26.257,15.135v23.985
	c0,3.627,2.901,6.528,6.528,6.528c3.627,0,6.528-2.901,6.528-6.528v-27.37l29.062,16.828c-5.996,3.433-12.863,4.062-17.747,6.963
	C140.552,184.336,138.086,191.01,138.086,191.01z M97.321,129.984l-7.689-4.449l0,0l9.139-15.764h10.252L97.321,129.984z
	 M114.198,139.752l7.253-12.669l5.416,19.923L114.198,139.752z M241.583,217.906H14.417c-4.457,0-8.594-2.406-10.797-6.28
	s-2.157-8.66,0.122-12.49L117.325,8.166c2.261-3.802,6.252-6.072,10.675-6.072c4.423,0,8.414,2.27,10.675,6.072l113.583,190.97
	c2.278,3.83,2.325,8.616,0.122,12.49C250.177,215.499,246.04,217.906,241.583,217.906z M15.876,206.353L15.876,206.353
	c0.001-0.001,0.001-0.002,0.002-0.003L15.876,206.353z M17.402,203.787h221.196L128,17.837L17.402,203.787z"/>
                </svg>
                {/* Message */}
                <Typography
                    color="white"
                    variant="h5"
                    fontWeight="bold"
                    textAlign="center"
                >
                    {message}
                </Typography>

                {/* Subtext */}
                <Typography
                    color="white"
                    variant="body2"
                    mt={1}
                    textAlign="center"
                    sx={{ maxWidth: "300px" }}
                >
                    This page is currently under development.
                </Typography>
                <Typography
                    color="white"
                    variant="body2"
                    mt={1}
                    textAlign="center"
                    sx={{ maxWidth: "300px" }}
                >
                    หน้านี้กำลังอยู่ในระหว่างการพัฒนา
                </Typography>
            </Box>
        </Box>
    );
};

export default HoverOverlay;